// let base = "http://admin.inovacetech.com/inovace-admin/api/v1/"
// let base = "http://test.admin.inovacetech.com/inovace-admin/api/v1/"
// let base = "http://127.0.0.1:8081/inovace-admin/api/v1/"
let base = window.location.origin + "/inovace-admin/api/v1/";
if(window.location.hostname === "localhost" || window.location.hostname === "127.0.0.1") base = "http://127.0.0.1:8081/inovace-admin/api/v1/";
export const API = {
	auth: {
		signIn: base + "auth/signin"
	},
	version: {
		versionList: base + "version/list",
		versionNameList: base + "version/list/names",
		versionConfigure: base + "version/add-module"
	},
	modules: {
		moduleList: base + "module/list",
		moduleStore: base + "module"
	},
	subscriptions: {
		all: base + "subscription/all/",
		subscriptionPeriodList: base + "subscription/periods/",
		paymentOptionList: base + "subscription/payment-options/",
		pricingOptionList: base + "subscription/pricing-options/",
		subscribe: base + "subscription/subscribe/",
		delete: base + "subscription/delete/",
		update: base + "subscription/edit/",
		expired: base + "subscription/expired/"
	},
	office: {
		officeList: base + "office/",
		officeListForPF: base + "office/payroll/",
		create: base + "office/create",
		getByProjectIdList: base + "office/by-project-id-list",
		updateModule: "/update-module",
		sendPayrollActivationEmail : base + "office/send-payroll-activation-mail",
		deviceList: base + "office/devices/all/"
	},
	officePfConfig:{
		getOfficePfConfigByOfficeId: base + "office-pf-config/office/",
		saveOfficePfConfig: base + "office-pf-config/save",
	},
	company: {
		companyList: base + "company/",
		create: base + "company/create",
		update: base + "company/update/"
	},
	invoice: {
		unpaid                : base + "invoices/unpaid/",
		unapproved            : base + "invoices/unapproved/",
		approved              : base + "invoices/approved/",
		approve               : base + "invoices/approve/",
		edit               : base + "invoices/update-invoice/",
		invoiceListOfAProject : base + "invoices/",
		download							: base + "invoices/download/"
	},
	payment: {
		historyList: {
			all: base + "payment-history/all/",
			invoice: base + "payment-history/invoice/"
		},
		create: base + "payment-history/create/",
		downloadInvoice : base + "payment-history/download-invoice/"
	},
	customer: {
		all: base + "customer/list",
		projectNames: base + "customer/project-names",
		updateCustomer : base + "customer/",
		updateApiAccess : base + "customer/enableAccess/",
		generateApiToken : base + "customer/api-token/",
		mailApiToken : base + "customer/api-token/mail/",
		createProject : base + "customer/create-project",
		projectDeviceList : base + "customer/devices/",
		assignSupportEmployee : base + "customer/support/assign",
		getAvailableSupportEmployees : base + "customer/support/available-employees",
		getAllCustomerSupportDetails : base + "customer/support/details",
		cloneTemporaryAllocations : base + "customer/support/temporary-allocations/clone",
		downloadArchivedReport : base + "customer/support/archived-report/download",
	},
	employee:{
		all: base + "employee/",
		employeeList : base + "employee/all-employees/",
		updateManagerOrApproverConfig : base + "employee/update-config/",
		setEmployeeRole : base + "employee/set-role/",
		existingPayrollStaff: base + "employee/payroll-staffs/",
		removePayrollStaff: base + "employee/remove-payroll-staff/"
	},
	reseller: {
		all: base + "resellers/",
		stock: base + "resellers/stock/"
	},
	companyGroup    : {
		all: base + "company-groups/",
		create: base + "company-groups/create",
		update:  base + "company-groups/update/",
	},
	purchaseOrder   : {
		all: base + "purchase-orders/",
		create: base + "purchase-orders/create",
		undelivered: base + "purchase-orders/undelivered",
		delivered: base + "purchase-orders/delivered",
		update: base + "purchase-orders/update/",
		exportAsExcel: base + "purchase-orders/export-excel"
	},
	deliveryDetails : {
		all                     : base + "delivery-details/",
		create                  : base + "delivery-details/create",
		replace                 : base + "delivery-details/replace",
		getByPurchaseOrderId    : base + "delivery-details/all-devices?purchaseOrderId=",
		downloadDeliveryReceipt : base + "delivery-details/download-delivery-receipt/",
		update                  : base + "delivery-details/update/"
	},
	generalSettings : {
		all	: base + "general-settings/",
		parking : base + "general-settings/dummy/parking-management",
		membership : base + "general-settings/dummy/membership-management",
		site : base + "general-settings/dummy/site-management"
	},
	department : {
		all : base + "department/"
	}
};

